<template>
  <section class="pb-32">
    <h3 class="heading-2 mb-12">
      {{ props.categories?.title }}
    </h3>

    <template v-if="isSearchBarVisible">
      <TradeInSearchBar
        class="mb-32"
        :defaultOptionLabel="i18n(translations.swapSelectLabelOptionDefault)"
        :display-select-example="false"
        zone="swap_categories"
        @default-item-selected="handleDefaultItemSelected"
        @item-selected="handleItemSelected"
      />

      <p class="heading-3">
        {{ i18n(translations.select) }}
      </p>
    </template>

    <RevButtonBase
      v-for="option in props.categories?.options"
      :key="option?.value"
      class="bg-action-default-low shadow-short rounded-lg mt-8 flex w-full cursor-pointer items-center gap-12 p-8 hover:bg-action-default-low"
      :data-qa="`category-${option.value}`"
      @click="$emit('next-step', { category: option.value })"
    >
      <RevIllustration
        v-if="option.icon?.light"
        alt=""
        class="rounded-md"
        :height="48"
        :src="option.icon.light"
        :width="64"
      />

      <div class="grow text-left">
        <p class="body-1">
          {{ option.label }}
        </p>
      </div>

      <p v-if="option.maxPriceEstimate" class="text-static-default-low body-2">
        {{
          i18n(translations.upToPrice, {
            price: i18n.price(option.maxPriceEstimate, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }),
          })
        }}
      </p>
    </RevButtonBase>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import type {
  BuybackProduct,
  Question,
} from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import TradeInSearchBar from '@backmarket/nuxt-layer-buyback/app/scopes/offer/components/TradeInSearchBar/TradeInSearchBar.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Categories.translations'

interface CategoriesProps {
  categories: Question | Record<string, never>
}

export interface CategoryPayload {
  category: string
}

const isSearchBarVisible = ref<boolean>(true)

const props = withDefaults(defineProps<CategoriesProps>(), {
  categories: () => ({}),
})

const emit = defineEmits<{
  (e: 'next-step', category: CategoryPayload): void
  (e: 'item-selected', item: BuybackProduct): void
}>()

const i18n = useI18n()

function handleItemSelected(item: BuybackProduct) {
  emit('item-selected', item)
}

function handleDefaultItemSelected() {
  isSearchBarVisible.value = false
}
</script>
